// eslint-disable-next-line
import { injectable } from "inversify";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";
import { IFetchListArgs, IPagedData } from '../../stores/abstract-paged-data-store';
import { createPagedRequestURLSearchParams } from '../helpers';

export interface ITransaction {
    id: number;
    user_id: number;
    customer_id: number;
    credits: number;
    credits_formatted: string;
    cash: number;
    cash_formatted: string;
    transaction_type_id: number;
    order_name: string;
    rma_id: number;
    product_case_id: number;
    gift_card: number;
    gift_card_formatted: string;
    refund_ids: string;
    conversion_rate: number;
    currency_code: string;
    is_automatic: boolean;
    created_at: string;
    updated_at: string;
    deleted_at?: string;
    order_id: number;
    refund_provider?: string;
    store_name: string;
    admin_customer_url: string;
    is_incentive: boolean;
    status: TRANSACTION_STATUSES;
    platform_transaction_id?: number;
}

export enum TRANSACTION_TYPES {
    STORE_SPENT = 1,
    ACCEPTED_OFFER = 2,
    DECLINED_OFFER = 3,
    ORIG_PAYMENT = 4,
    CREDIT_ADJUSTMENT_ISSUE = 5,
    CREDIT_ADJUSTMENT_WITHDRAW = 6,
    INSTANT_REFUND_TYPE = 7,
    REFUND_TO_BANK = 8,
    INVOICE_ADJUSTMENT_NEGATIVE = 9,
    INVOICE_ADJUSTMENT_POSITIVE = 10,
    INVOICE = 11,
    PAYMENT_AUTHORIZATION = 12,
    PAYMENT_CAPTURE = 13
}

export enum TRANSACTION_STATUSES {
    REQUESTED = "1",
    SUCCESS = "2",
    CANCELED = "3",
    FAILED = "4"
}

export interface IFetchTransactionListArgs extends IFetchListArgs {
    search_customer_id: string;
    filter_action_ids: string;
    filter_date_range: string;
}

@injectable()
class TransactionsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchList(args: IFetchTransactionListArgs): Promise<IPagedData<ITransaction>> {
        const { page, perPage, sortBy, sortDir, search_customer_id, filter_action_ids, filter_date_range } = args;
        const searchParams = createPagedRequestURLSearchParams(page, perPage, sortBy, sortDir);

        if (search_customer_id) {
            searchParams.append('search_customer_id', search_customer_id);
        }

        if (filter_action_ids) {
            searchParams.append('action_ids', filter_action_ids);
        }

        if (filter_date_range) {
            searchParams.append('date_range', filter_date_range);
        }

        const res = await this.httpService.get<IApiResponse<IPagedData<ITransaction>>>
            (`/rms-api/transactions?${searchParams.toString()}`);

        return res.payload;
    }
}

export default TransactionsService;
